<kal-button (click)="stopPropagation($event)"
            *ngIf="hasComment"
            [kalMenuTriggerFor]="commentMenu"
            kalTheme="tertiary">
    <kal-icon>chat_bubble_outline</kal-icon>
</kal-button>
<kal-menu #commentMenu>
    <ng-container *ngFor="let displayComment of displayedCommentsList">
        <kal-option class="shared-comment-table">
            <strong>{{displayComment.label}}</strong>
            <div *ngFor="let commentLine of displayComment.comment.split('\n')">{{ commentLine }}</div>        </kal-option>
    </ng-container>
</kal-menu>
